import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField", "submitArea"]

  connect() {
    this.updateSubmitVisibility(this.hiddenFieldTarget.value || 'setup')

    // Listen for Bootstrap tab change events
    this.element.querySelectorAll('[data-bs-toggle="pill"]').forEach(tab => {
      tab.addEventListener('shown.bs.tab', (e) => {
        const tabName = e.target.getAttribute('href').replace('#', '')
        this.hiddenFieldTarget.value = tabName
        this.updateSubmitVisibility(tabName)
      })
    })
  }

  updateSubmitVisibility(tabName) {
    const formTabs = ['setup', 'assessor-org', 'messages', 'roles']
    const isFormTab = formTabs.includes(tabName)
    if (this.hasSubmitAreaTarget) {
      this.submitAreaTarget.style.display = isFormTab ? '' : 'none'
    }
  }
}
